module.exports = __webpack_public_path__ + "static/media/no_suggestion.88475398.svg";